<ng-container *ngIf="layoutCrwData$ | async as layoutCrwData; else loading">
  <main>
    <router-outlet />
  </main>
</ng-container>
<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
